import React from "react";
import OrderDetailRow from "./form/OrderDetailRow";
import { CheckCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { Divider } from "antd";
import { OrderHistoryType } from "../types/OrderHistoryType";
import { ReactComponent as FilledCircle } from "../assets/check-circle-filled.svg";
import { ReactComponent as DashedLine } from "../assets/dashedLine.svg";

const OrderHistory = ({
	date,
	statusChangeComment,
	userName,
	phone,
	statusId,
}: OrderHistoryType) => {
	const formatDateString = (inputDate: string) => {
		const options: Intl.DateTimeFormatOptions = {
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
			hour: "2-digit",
			minute: "2-digit",
		};
		const formattedDate = new Date(inputDate).toLocaleString(
			"en-GB",
			options
		);
		return formattedDate.replace(",", "").replace(/\//g, ".");
	};

	const formattedDate = formatDateString(date);
	return (
		<>
			<div className="flex flex-col gap-5 ">
				<div className="flex flex-row items-start gap-6">
					<div className=" flex flex-col items-center gap-2 pb-2">
						{statusId === 6 ? (
							<FilledCircle
								style={{
									fontSize: "30px",
									color: "#36B37E",
								}}
							/>
						) : (
							<ClockCircleOutlined
								style={{
									fontSize: "30px",
									color: "#36B37E",
								}}
							/>
						)}

						{<DashedLine />}
					</div>
					<div className="flex flex-col gap-1 ">
						<p className="font-inter font-normal font-medium text-[12px] leading-[15px] text-[#767676] ">
							{formattedDate}
						</p>
						<p className="font-inter font-medium text-base leading-[17px] text-[#2C2C2C] mt-1">
							{statusChangeComment}
						</p>
						<p className="font-inter font-medium text-[12px] leading-[15px] text-[#767676]">
							{userName}
						</p>
					</div>
				</div>
			</div>
		</>
	);
};

export default OrderHistory;
